"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const common_1 = require("@Const/common");
const PointPreloader = () => (react_1.default.createElement("div", { className: "point-preloader" },
    react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'overlay' }),
        react_1.default.createElement("img", { className: 'circle', src: common_1.ICONS.preloader_circle, alt: "preloader" }))));
exports.default = PointPreloader;
